import request from "@/utils/request";

export function sendNavigation(data) {
  return request({
    url: "/notenavigation/api",
    method: "post",
    data
  });
}

// 获取历史数据(GPS)
export function getHistoryMapTrace(id) {
  return request({
    url: "/new/version/history/gps-data",
    method: "get",
    params: { id }
  });
}

